import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.styl';
import success from '../../assets/images/feedback-correct.svg';
import error from '../../assets/images/feedback-incorrect.svg';
import retry from '../../assets/images/feedback-try-again.svg';

class Feedback extends Component {
  constructor(props) {
    super(props);

    this.wrapperElement = null;
  }

  componentDidMount() {
    if (this.props.scrollOnMount && this.wrapperElement) {
      this.wrapperElement.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    }
  }

  setWrapperElementRef = element => {
    // TODO: this ref could be updated to use React.createRef() instead if this project is updated to React 16.3+
    this.wrapperElement = element;
  };

  determineFeedbackIcon() {
    const { feedbackType } = this.props;
    if (feedbackType === 'success') {
      return success;
    } else if (feedbackType === 'retry') {
      return retry;
    } else {
      return error;
    }
  }

  render() {
    return (
      <div className="feedback-wrapper" ref={this.setWrapperElementRef}>
        <div className="feedback">
          <img
            alt=""
            className="feedback__upper-img"
            src={this.determineFeedbackIcon()}
          />
          <h2>{this.props.title}</h2>
          {this.props.body}
          {this.props.children}
        </div>
      </div>
    );
  }
}

Feedback.defaultProps = {
  scrollOnMount: true
};

Feedback.propTypes = {
  body: PropTypes.node.isRequired,
  feedbackType: PropTypes.string,
  scrollOnMount: PropTypes.bool,
  title: PropTypes.string.isRequired
};

export default Feedback;



// WEBPACK FOOTER //
// ../core/src/components/Feedback/index.js